<template>
  <v-card
    class="mx-auto mt-4"
    style="max-width: 500px;"
  >

    <v-toolbar
      color="blue darken-2"
      cards
      dark
      height="70px"
    >
      <v-spacer></v-spacer>
      <v-card-title class="title font-weight-regular">You better log in!</v-card-title>
      <v-spacer></v-spacer>
    </v-toolbar>

    <v-form
      ref="form"
      class="pa-3 pt-4"
    >

      <v-text-field
        v-model="email"
        name="email"
        color="deep-purple"
        label="Email"
        type="email"
        hide-details
        v-validate="'required|email'"
        :class="{'mb-3': !errors.has('email')}"
      ></v-text-field>
      <div class="red--text mb-4">{{ errors.first('email') }}</div>

      <v-text-field
        v-model="password"
        name="password"
        ref="password"
        color="deep-purple"
        counter="6"
        label="Password"
        type="password"
        hide-details
        v-validate="'required'"
        :class="{'mb-3': !errors.has('password')}"
        @change="signInUser"
      ></v-text-field>
      <div class="red--text mb-4">{{ errors.first('password') }}</div>

    </v-form>

    <v-card-actions>

      <v-spacer></v-spacer>
      <v-btn
        class="white--text"
        color="blue darken-2"
        large
        @click="signInUser"
      >Login</v-btn>
      <v-spacer></v-spacer>
    </v-card-actions>

    <br>
    <br>

    <v-card-actions>

      <v-spacer></v-spacer>
      <div class="text-xs-center">
        <p>Don't have an account?</p>

        <v-btn
          class="white--text"
          color="blue darken-2"
          flat
          small
          to="/register"
        >Register</v-btn>

      </div>

      <v-spacer></v-spacer>
    </v-card-actions>

  </v-card>
</template>

<script>
export default {
  data () {
    return {
      email: null,
      password: null
    }
  },
  methods: {
    signInUser () {
      this.$validator.validate().then(result => {
        if (!result) {
          console.log('still errors there')
        } else {
          this.$store.dispatch('signInUser', { email: this.email, password: this.password })
        }
      })
    }
  },
  computed: {
    user () {
      return this.$store.getters.user
    }
  },
  watch: {
    user (value) {
      if (value !== null || value !== undefined) {
        this.$router.push('/address-book')
      }
    }
  }
}
</script>

<style>
  @media(max-width: 550px) {
    .v-card {
      box-shadow: none !important;
    }
  }
</style>
